import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../Mobile.css';

function Company() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default Company